import React from 'react'

function AuditTrailHeader() {
  return (
    <div className="flex flex-col gap-1 w-full p-8 pb-4 mb-5">
      <p className="text-3xl font-semibold text-[#181d27]">
        Audit Trail
      </p>
      <p className="text-[16px] text-[#535862]">
        List of record for all system activities and events.
      </p>
    </div>
  )
}

export default AuditTrailHeader
